import React, {FC} from 'react';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {getColorHighlight, getEmojiHighlight} from '../../../../../helpers/models/highlightHelpers';
import {TagModel} from '../../../../../models/api/tagModel';
import {Emoji} from '../../../../common/emoji/emoji';

/*
 * Props.
 */

interface SearchSuggestionsDropdownTagItemIconProps {
  tag: TagModel;
}

/*
 * Component.
 */

export const SearchSuggestionsDropdownTagItemIcon: FC<SearchSuggestionsDropdownTagItemIconProps> = (
  props,
) => {
  const {tag} = props;

  const theme = useUserTheme();

  const emojiHighlight = getEmojiHighlight(tag);

  if (emojiHighlight) {
    return <Emoji emoji={emojiHighlight.emoji} skinTone={emojiHighlight.skinTone} size={16} />;
  }

  const colorHighlight = getColorHighlight(tag);
  const iconColor = colorHighlight && theme.palette[colorHighlight].shade40;

  return <Icon name="tagSmall" color={iconColor || theme.greys.shade70} />;
};
